import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ICertification } from "../models/certifications";

@Injectable({
  providedIn: "root",
})
export class CertificationService {
  public baseUrl: string = "/certification";
  public list: ICertification[] = [];
  public list_enabled: ICertification[] = [];

  constructor(private _httpClient: HttpClient) {}

  async getList(force: boolean = false) {
    if (this.list.length > 0 && force) return this.list;

    return this._httpClient
      .get("/certification?enabled=2")
      .toPromise()
      .then((response: ICertification[]) => {
        this.list = response;
        this.list_enabled = response.filter((cert: ICertification) => cert.enabled === 1);
        return response;
      })
      .catch((err) => {
        console.error("JobSiteService getList", err);
        return [];
      });
  }

  async delete(id: number) {
    return this._httpClient
      .delete(this.baseUrl + "/" + id)
      .toPromise()
      .then(async (response) => {
        await this.getList();
        return response;
      });
  }

  async create(data: ICertification) {
    return this._httpClient
      .post(this.baseUrl, data)
      .toPromise()
      .then(async (response) => {
        await this.getList();
        return response;
      });
  }

  async update(id: number, data: { name: string }) {
    return this._httpClient
      .put(this.baseUrl + "/" + id, data)
      .toPromise()
      .then(async () => {
        await this.getList();
      });
  }

  async approve(id: number) {
    return this._httpClient
      .put(`/certification/${id}/approve`, {})
      .toPromise()
      .then(async () => {
        await this.getList();
      });
  }

  async reject(id: number) {
    return this._httpClient
      .put(`/certification/${id}/reject`, {})
      .toPromise()
      .then(async () => {
        await this.getList();
      });
  }
}
